import React from 'react';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

import { getField, formatNumber } from 'src/common/helper';
import InputCustom from 'src/components/master/doctorFee/InputCustom';

export const fontPrice = {
  fontSize: '14px',
  fontWeight: 500,
  lineHeight: '14.4px',
  whiteSpace: 'nowrap'
};

type RecordItemProps = {
  item: any;
  index: number;
  surgery: any;
  onChange: (index: number, fieldName: string, value: number | null) => void;
};

const RecordItem: React.FC<RecordItemProps> = (props) => {
  const handleChange = (fieldName: string) => (value: number | string | null) => {
    props.onChange(props.index, fieldName, Number(value));
  };

  const roundToNearestThousand = (value: number) => {
    return Math.ceil(value / 1000) * 1000;
  };

  const calPercent = (price: number, percent: number | null) => {
    if (percent !== null) {
      return roundToNearestThousand(price + (price / 100) * percent);
    }
    return price;
  };

  return (
    <TableRow
      hover
      key={props.item.id}
      sx={{
        '&:last-child td, &:last-child th': { border: 0 },
        '& .MuiTableCell-root.MuiTableCell-body': {
          py: '8px',
          borderBottom: '1px solid #F3F3F3',
          fontSize: '14px',
          fontWeight: 400,
          lineHeight: '14.4px'
        },
        height: '48px',
      }}
    >
      <TableCell component='td' scope='row' align={'left'}>
        <Typography
          sx={{
            whiteSpace: 'pre-wrap',
            fontSize: '14px',
            fontWeight: 400,
            lineHeight: '14.4px'
          }}>
          {getField(props.item, 'name', '-')}
        </Typography>
      </TableCell>

      <TableCell component='td' scope='row' align={'left'}>
        <Stack direction={'row'} spacing={'10px'} alignItems={'center'}>
          <Typography
            component={'label'}
            sx={{
              ...fontPrice,
              color: getField(props.item, 'changed', 0) === 1 ? '#23b7e5' : ''
            }}>
            {formatNumber(calPercent(getField(props.surgery, 'price', 0), getField(props.item, 'price_pct', null))) + '円'}
          </Typography>
          <InputCustom
            name='price_pct'
            onChange={handleChange('price_pct')}
            type='number'
            min={-100}
            max={100}
            value={getField(props.item, 'price_pct', null)}
            sx={{ width: '100%' }}
          />
        </Stack>
      </TableCell>

      <TableCell component='td' scope='row' align={'left'}>
        <Stack direction={'row'} spacing={'10px'} alignItems={'center'}>
          <Typography
            component={'label'}
            sx={{
              ...fontPrice,
              color: getField(props.item, 'changed', 0) === 1 ? '#23b7e5' : ''
            }}>
            {formatNumber(calPercent(getField(props.surgery, 'price_mornitor', 0), getField(props.item, 'price_monitor_pct', null))) + '円'}
          </Typography>
          <InputCustom
            name='price_pct'
            onChange={handleChange('price_monitor_pct')}
            type='number'
            min={-100}
            max={100}
            value={getField(props.item, 'price_monitor_pct', null)}
            sx={{ width: '100%' }}
          />
        </Stack>
      </TableCell>
    </TableRow >
  );
};

export default RecordItem;
